"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CrmPill = void 0;
var react_1 = __importDefault(require("react"));
var icons = __importStar(require("@qwilr/kaleidoscope/icons"));
var lodash_1 = require("lodash");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var Types_1 = require("@CommonFrontendBackend/Tokens/Types");
var c = (0, BemBuilder_1.default)("crm-pill");
var CrmPill = function (props) {
    var _a = props.crmInfo, connected = _a.connected, integration = _a.integration, object = _a.object;
    var integrationMetadata = Types_1.INTEGRATION_METADATA.get(integration);
    var crmIcon = getCrmIcon(props.crmInfo);
    return (react_1.default.createElement(react_1.default.Fragment, null, connected && integrationMetadata && (react_1.default.createElement(kaleidoscope_1.Card, { className: c() },
        react_1.default.createElement(kaleidoscope_1.Text, { className: c("object") }, object),
        crmIcon && react_1.default.createElement(kaleidoscope_1.Tooltip, { content: integrationMetadata.displayName }, crmIcon)))));
};
exports.CrmPill = CrmPill;
var getCrmIcon = function (crmInfo) {
    var Icon = ((crmInfo === null || crmInfo === void 0 ? void 0 : crmInfo.integration) && icons[(0, lodash_1.capitalize)(crmInfo === null || crmInfo === void 0 ? void 0 : crmInfo.integration)]) || icons.Tokens;
    return react_1.default.createElement(Icon, { className: "icon" });
};
